import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Gallery from "@/components/sections/Gallery";
import { Reveal } from "@/components/site/motion";

const GalleryPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="gallery-page" className="bg-sand min-h-screen">
      <Navbar />
      <section className="pt-40 md:pt-48 pb-4">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal>
            <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Virtual Tour</p>
            <h1 className="font-serif text-5xl md:text-7xl text-forest tracking-tight leading-[0.98]">Take a Look Inside</h1>
            <p className="mt-6 text-lg text-ink2 max-w-2xl leading-relaxed">
              Our residential treatment facility is meant to have you feel at home, located near the scenic Scarborough Bluffs.
            </p>
          </Reveal>
        </div>
      </section>
      <Gallery />
      <Footer />
    </div>
  );
};

export default GalleryPage;
